import { render, staticRenderFns } from "./r-datetextpicker.vue?vue&type=template&id=061c95be&"
import script from "./r-datetextpicker.vue?vue&type=script&lang=js&"
export * from "./r-datetextpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports